import type { TextFontWeightModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import FontWeightSelector from "@/features/react-editor/components/modifiers/base/FontWeightSelector";
import { useDefaultSelectedElementDesignation } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";

interface FontWeightModifierProps {
  onChange: (modifiers: TextFontWeightModifierValue[]) => void;
}

const FontWeightModifierComponent: React.FC<FontWeightModifierProps> = ({
  onChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  const currentValue =
    defaultDesignation?.element.styleOverrides?.fontWeight ?? null;
  const fontFamily =
    defaultDesignation?.element.styleOverrides?.fontFamily ?? null;

  const handleValueChange = (weight: number | null) => {
    if (weight) {
      onChange([
        {
          type: "fontWeight" as const,
          value: weight,
        },
      ]);
    }
  };

  return (
    <div className="font-weight-modifier">
      <FontWeightSelector
        fontWeight={currentValue}
        onSelect={handleValueChange}
        placeholder="Select weight"
        fontFamily={fontFamily}
      />
    </div>
  );
};

export default FontWeightModifierComponent;
